import axios from 'axios'
import config from "../config";

export default {
  methods: {
    // ...es6 destructuring...
    // https://hacks.mozilla.org/2015/05/es6-in-depth-destructuring/
    // { variable = value } --> that is setting a default value
    axiosMethod({ methodType = 'get', url, params, onSuccess, onError, onExtraParam}) {
      url = config.baseApiUrl + url
      axios[methodType](url, params)
        .then((response) => onSuccess && onSuccess(response, onExtraParam) )
        .catch((error) => onError && onError(error, onExtraParam) )
    },
  },
}
